import * as url from "../url_helper";

import { post } from "../api_helper";

export const getPaymentTermsList = data => post(url.GET_PAYMENT_TERMS_LIST, data);